module.exports = __webpack_public_path__ + "static/img/ccc.27fc5a9f.png";